import React from "react";
import { IconColor } from "../interface/ColorInterface";

const PagesIconSvg: React.FC<IconColor> = ({
  color,
  width,
  height,
  transform,
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.998 6.00131V4.28562C15.998 3.51709 15.998 3.13283 15.8367 2.88443C15.6956 2.66709 15.4756 2.51302 15.2232 2.45467C14.9346 2.38799 14.5735 2.51931 13.8512 2.78195L6.57787 5.42682C6.00869 5.63379 5.7241 5.73728 5.5142 5.91967C5.32878 6.08078 5.18577 6.28497 5.09773 6.51427C4.99805 6.77387 4.99805 7.07668 4.99805 7.68233V12.0013M8.99805 17.0013H14.998M8.99805 13.5013H14.998M8.99805 10.0013H14.998M8.19805 21.0013H15.798C16.9181 21.0013 17.4782 21.0013 17.906 20.7833C18.2823 20.5915 18.5883 20.2856 18.78 19.9093C18.998 19.4814 18.998 18.9214 18.998 17.8013V9.20131C18.998 8.0812 18.998 7.52115 18.78 7.09333C18.5883 6.717 18.2823 6.41104 17.906 6.21929C17.4782 6.0013 16.9181 6.00131 15.798 6.00131H8.19805C7.07795 6.00131 6.51789 6.0013 6.09007 6.21929C5.71374 6.41104 5.40778 6.717 5.21604 7.09333C4.99805 7.52115 4.99805 8.0812 4.99805 9.20131V17.8013C4.99805 18.9214 4.99805 19.4814 5.21604 19.9093C5.40778 20.2856 5.71374 20.5915 6.09007 20.7833C6.51789 21.0013 7.07794 21.0013 8.19805 21.0013Z"
        stroke={color || "white"}
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PagesIconSvg;
